import { useSelector } from 'react-redux';

export function Permissions() {
  const { permissions: permissions } = useSelector((state) => state.user);

  return permissions;
}
